module.exports = __webpack_public_path__ + "img/Yenka_80X30.1828944a.png";